import { Box, Divider, styled, Typography } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import React, { useEffect, useState } from "react";
import storebanner from "../assets/images/store-baner.webp";
const Wrapper = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    position: "relative",
    zIndex: -10,
  })
);

const Section = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme, hover }) => ({
    width: "100%",
    [theme.breakpoints.up("xs")]: { height: "300px" },
    [theme.breakpoints.up("sm")]: { height: "400px" },
    [theme.breakpoints.up("md")]: { height: "500px" },
    [theme.breakpoints.up("lg")]: { height: "550px" },
    backgroundImage: `url(${storebanner})`,
    // backgroundPositionY:`${hover * 0.09}px`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",

    //    width:'100%',
    //     [theme.breakpoints.up('xs')]:{height:'300px'},
    //     [theme.breakpoints.up('sm')]:{height:'400px'},
    //     [theme.breakpoints.up('md')]:{height:'500px'},
    //     [theme.breakpoints.up('lg')]:{height:'500px'},
    //     zIndex:-10,
    //    '&:after':{
    //     content:"''",
    //     width:'100%',
    //     height:'850px',
    //     position:'absolute',
    //     top:0,
    //     backgroundImage:`url(${storebanner})`,
    //     transform:`translateY(${-hover * 0.06}px)`,
    //     // transform:'translateZ(-10px) scale(2)',
    //     backgroundSize:'cover',
    //     backgroundRepeat:'no-repeat',
    //    }
  })
);
const Card = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    position: "absolute",
    zIndex: 5,
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",

    background: "rgba(181, 150, 119,0.8)",

    "& .title , & .openingHours": {
      color: "white",
      fontFamily: "Montserrat,sans-serif",
      fontWeight: 600,
    },
    "& .address , & .hours": {
      color: "white",
      fontFamily: "lato,sans-serif",
    },
    "& .divider": {
      width: "30%",
      height: "2px",
      background: "white",
      margin: "10px 0",
      border: "none",
    },
    [theme.breakpoints.up("xs")]: {
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
      gap: theme.spacing(0.5),
      width: "80%",
    },
    [theme.breakpoints.up("sm")]: {
      padding: `${theme.spacing(4)} ${theme.spacing(0)}`,
      gap: theme.spacing(0.5),
      width: "60%",
    },
    [theme.breakpoints.up("md")]: {
      padding: `${theme.spacing(6)} ${theme.spacing(0)}`,
      gap: theme.spacing(1.4),
      width: "60%",
    },
    [theme.breakpoints.up("lg")]: {
      padding: `${theme.spacing(8)} ${theme.spacing(0)}`,
      gap: theme.spacing(1.4),
      width: "50%",
    },
  })
);
export default function Address() {
  const [hover, sethover] = useState(0);
  const handleHover = () => {
    console.log("windows", window.scrollY);
    sethover(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleHover);

    return () => {
      window.removeEventListener("scroll", handleHover);
    };
  }, []);

  return (
    <Wrapper>
      <Section className="section" hover={hover}>
        <Card>
          <Typography className="title" variant={"h5"}>
            GECKO STORE
          </Typography>
          <Typography className="address" variant={"body2"}>
            184 Main Rd E, St Albans VIC 3021, Australia
          </Typography>
          <Divider className="divider" />
          <Typography className="openingHours" variant={"body1"}>
            Opening Hours
          </Typography>
          <Typography className="hours" variant={"body2"}>
            Monday to Friday: 9:00 AM – 9:00 PM
          </Typography>
          <Typography className="hours" variant={"body2"}>
            Saturday to Sunday: 9:30 AM – 8:00 PM
          </Typography>
        </Card>
      </Section>
    </Wrapper>
  );
}
